import React from 'react';
import { ChevronsLeft, ChevronsRight, ChevronLeft, ChevronRight } from 'lucide-react';
import './customPagination.css';

export default function CustomPagination({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  selectOptions = ['5', '10', '15', '20', '25'],
  totalPages,
  disabled = false,
}) {
  if (totalItems <= 0) return null;

  const firstItem = (currentPage - 1) * itemsPerPage + 1;
  const lastItem = Math.min(currentPage * itemsPerPage, totalItems);
  const isFirstPage = currentPage <= 1;
  const isLastPage = currentPage >= totalPages;

  return (
    <div className="ca-custom-pagination" aria-label="Complaint table pagination">
      <label className="ca-custom-pagination__page-size">
        <span>Results per page:</span>
        <select
          className="ca-custom-pagination__select"
          value={String(itemsPerPage)}
          onChange={(event) => onItemsPerPageChange?.(Number(event.target.value))}
          disabled={disabled}
          aria-label="Results per page"
        >
          {selectOptions.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </label>

      <div className="ca-custom-pagination__navigation">
        <button
          type="button"
          className="ca-custom-pagination__button"
          onClick={() => onPageChange?.(1)}
          disabled={disabled || isFirstPage}
          aria-label="First page"
        >
          <ChevronsLeft size={16} aria-hidden="true" />
        </button>
        <button
          type="button"
          className="ca-custom-pagination__button"
          onClick={() => onPageChange?.(currentPage - 1)}
          disabled={disabled || isFirstPage}
          aria-label="Previous page"
        >
          <ChevronLeft size={16} aria-hidden="true" />
        </button>
        <span className="ca-custom-pagination__range">{firstItem} - {lastItem} of {totalItems}</span>
        <button
          type="button"
          className="ca-custom-pagination__button"
          onClick={() => onPageChange?.(currentPage + 1)}
          disabled={disabled || isLastPage}
          aria-label="Next page"
        >
          <ChevronRight size={16} aria-hidden="true" />
        </button>
        <button
          type="button"
          className="ca-custom-pagination__button"
          onClick={() => onPageChange?.(totalPages)}
          disabled={disabled || isLastPage}
          aria-label="Last page"
        >
          <ChevronsRight size={16} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}